export enum UserRole {
  Admin = 'ADMIN',
  Operator = 'OPERATOR',
  OperatorWithoutPBAccess = 'OPERATOR_WITHOUT_PB_ACCESS',
  DeviceOperator = 'DEVICE_OPERATOR',
  OperatorReadAccess = 'OPERATOR_READ_ACCESS',
  TtmOperator = 'TTM_OPERATOR',
  DeviceQualityOperator = 'DEVICE_QUALITY_OPERATOR',
}
